import React from "react";
import "./typing-indicator.css";

// TypingIndicator component
const TypingIndicator: React.FC = () => {
  return (
    <span className="relative flex flex-row gap-1">
      {[...Array(3).keys()].map((index) => (
        <span
          key={index}
          className={`dot 
          bg-[#3b5998] rounded-full
            
          `}
          style={{
            animationDelay: `${index * 0.2}s`,
          }}
        />
      ))}
    </span>
  );
};

export default TypingIndicator;

// absolute top-0 left-0

// ${index === 1 ? "ml-3" : ""}
//            ${
//             index === 2 ? "ml-6" : ""
//            }
